import { Avatar } from "xAppLib/Avatar/Avatar";

const UserPic = ({name, size = 24, className}) => {
	return (
		<Avatar
				name={name || 'Guest'}
				size={size}
				className={className}
			/>
	)
}
 
export default UserPic;
